import { UrlHelper } from 'utilities/UrlHelper/UrlHelper';

import { Environment } from 'Environment';

const RPCModel = require('RPCModel');

const MachineLearningProject = RPCModel.extend({
    className: 'MCS.machineLearning',

    addUrl: 'projects/:pid/services/vision',
    findOneUrl: 'projects/:pid/services/vision',

    defaults: {
        id: undefined,
        /**
         * Состояние доступности сервиса.
         * @type {string} – 'active', 'frozen' or 'suspended'
         */
        status: 'active',

        /**
         * Дата перевода сервиса в состояние 'frozen'.
         * @type {number} – TimeStamp (в секундах)
         */
        frozen_at: 0,

        /**
         * Дата перевода сервиса в состояние 'suspended'.
         * @type {number} – TimeStamp (в секундах)
         */
        suspended_at: 0,

        /**
         * Действующие лимиты.
         * @type {Object}
         */
        freeze: {
            /**
             * Баланс, при котором сервис
             * переводится в состояние 'frozen'.
             * @type {number} – в рублях (-0.01)
             */
            freeze_level: 0,

            /**
             * Максимальное время нахождения в состоянии 'frozen'.
             * @type {number} – в секундах
             */
            frozen_time: 0,

            /**
             * Баланс, при котором сервис
             * переводится в состояние 'suspended'.
             * @type {number} – в рублях (-1000)
             */
            suspend_level: 0,

            /**
             * Максимальное время нахождения в состоянии 'suspended'.
             * @type {number} – в секундах
             */
            suspended_time: 0,
        },
    },

    parse(body) {
        body.id = 0;

        return body;
    },

    prepareSendData() {
        return {
            metrics: Environment.utmParams,
        };
    },

    /**
     * Возвращает долг, по достижении которого сервис
     * переводится в состояние 'suspended'.
     * @returns {number} – в рублях
     */
    getSuspendDebt() {
        return this.get('freeze').suspend_level;
    },

    /**
     * @returns {number} – TimeStamp (в миллисекундах)
     */
    getSuspendDate() {
        const frozenAt = this.get('frozen_at');
        const frozenTime = this.get('freeze').frozen_time;

        return (frozenAt + frozenTime) * 1000;
    },

    getStatus() {
        return this.get('status').toLowerCase();
    },

    isLocked() {
        const status = this.getStatus();

        return status === 'frozen' || status === 'suspended';
    },
});

MachineLearningProject.url = UrlHelper.getModelUrlPidInjector();

export default MachineLearningProject;
